// extracted by mini-css-extract-plugin
export var boldText = "_3i-4";
export var checkboxContainer = "_3i-6";
export var closeIcon = "_3i-g";
export var container = "_3i-0";
export var drawer = "_3i-8";
export var drawerContent = "_3i-9";
export var extraSmallText = "_3i-5";
export var fulfillmentGroupTable = "_3i-e";
export var largeText = "_3i-3";
export var loadingSpinnerContainer = "_3i-h";
export var mediumText = "_3i-2";
export var narrow = "_3i-f";
export var notificationLink = "_3i-j";
export var packageCheckIconContainer = "_3i-7";
export var slideoutHeaderContainer = "_3i-a";
export var slideoutModal = "_3i-c";
export var stickyHeaderWrapper = "_3i-b";
export var table = "_3i-i";
export var tableContainer = "_3i-d";
export var tertiaryText = "_3i-1";